import confetti from "canvas-confetti";

const keywords = [
	"congrats",
	"Congrats",
	"congratulation",
	"Congratulation",
	"chúc mừng",
	"CHÚC MỪNG",
	"Chúc Mừng",
	"Chúc mừng",

	"chào mừng",
	"CHÀO MỪNG",
	"Chào Mừng",
	"Chào mừng",
	"xoxo",
	"Happy birthday",
	"HAPPY BIRTHDAY",
	"happy birthday",
	"Happy Birthday",

	"chúc mừng sinh nhật",
	"Chúc mừng sinh nhật",
	"sinh nhật",
	"SINH NHẬT",
	"Sinh Nhật",
	"Sinh nhật"
];

const colors = ["#bb0000", "#ffffff", "#2ecc71", "#f1c40f", "#ecf0f1"];

export default {
	mark: string => {
		/**
		 * replace all string
		 *
		 * @param  {string} str
		 * @param  {string} from
		 * @param  {string} to
		 * @return {string}
		 */
		let replaceAll = (str, from, to) =>
			str.replace(new RegExp(from, "g"), to);

		keywords.forEach(k => {
			string = replaceAll(
				string,
				k,
				`<span class="special-text">${k}</span>`
			);
		});

		/**
		 * run confetti
		 */
		let showConfetti = () => {
			const particle = 200;

			confetti({
				particleCount: particle,
				angle: 60,
				spread: 100,
				colors: colors,
				origin: { x: 0 }
			});
			confetti({
				particleCount: particle,
				angle: 120,
				spread: 100,
				colors: colors,
				origin: { x: 1 }
			});
		};

		document.body.addEventListener(
			"click",
			function(evt) {
				if (evt.target.classList.contains("special-text")) {
					let canvas = document.querySelector("canvas");
					!canvas && showConfetti();
				}
			},
			false
		);

		return string;
	},

	youtubeEmbed: (string, height = 345) => {
		let re = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?.*v=)?(\w+)/g;
		let vid = `<iframe width="100%" height="${height}" src="https://www.youtube.com/embed/$1" frameborder="0" allowfullscreen></iframe>`;

		return string.replace(re, vid);
	},

	nl2br: (str, is_xhtml) => {
		if (typeof str === "undefined" || str === null) {
			return "";
		}
		let breakTag =
			is_xhtml || typeof is_xhtml === "undefined" ? "<br />" : "<br>";
		return (str + "").replace(
			/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g,
			"$1" + breakTag + "$2"
		);
	},

	/**
	 * detect content including youtube, vimeo, dailymotion OR normal link
	 *
	 * @param  {String} string
	 * @param  {Number} height
	 * @return {String}
	 */
	link: (string, height = 345) => {
		let getInfo = url => {
			url.match(
				/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com)|dailymotion.com)\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(&\S+)?/
			);
			let type = "";
			if (RegExp.$3.indexOf("youtu") > -1) {
				type = "youtube";
			} else if (RegExp.$3.indexOf("vimeo") > -1) {
				type = "vimeo";
			} else if (RegExp.$3.indexOf("dailymotion") > -1) {
				type = "dailymotion";
			} else {
				type = "link";
			}

			return { type: type, id: RegExp.$6 };
		};

		let links = string.match(/\bhttps?:\/\/\S+/gi);
		links &&
			links.forEach(url => {
				let info = getInfo(url);

				if (info.type === "youtube") {
					string = string.replace(
						url,
						`<iframe width="100%" height="${height}" src="https://www.youtube.com/embed/${info.id}" frameborder="0" allowfullscreen></iframe>`
					);
				} else if (info.type === "vimeo") {
					string = string.replace(
						url,
						`<iframe width="100%" height="${height}" src="https://player.vimeo.com/video/${info.id}" frameborder="0" allowfullscreen></iframe>`
					);
				} else if (info.type === "dailymotion") {
					string = string.replace(
						url,
						`<iframe width="100%" height="${height}" src="https://www.dailymotion.com/embed/video/${info.id}" frameborder="0" allowfullscreen></iframe>`
					);
				} else {
					string = string.replace(
						url,
						`<p><a href="${url}" target="_blank">${url}</a></p>`
					);
				}
			});

		return string;
	}
};
